import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpHelper } from '@app/common/http-helper';
import { CacheService } from '@app/services/cache.service';
import { Drive, DriveItem } from '@microsoft/microsoft-graph-types';
import { Observable, of } from 'rxjs';
import { catchError, shareReplay, tap } from 'rxjs/operators';
import { Constants } from '../common/constants';

@Injectable({
  providedIn: 'root'
})
export class OneDriveService {

  constructor(private http: HttpClient, private cache: CacheService, private httpHelper: HttpHelper) { }

  private readonly cacheKey = 'OnedriveService-getOneDrive';
  public useCache = true;
  private getOneDrive$: Observable<Drive>;

  getOneDrive(): Observable<Drive> {
    if (this.getOneDrive$) {
      return this.getOneDrive$;
    } else {
      const httpParams = new HttpParams()
        .append('select', 'webUrl');

      this.getOneDrive$ = this.http.get<Drive>(`${Constants.GRAPH_API_ENDPOINT + Constants.GRAPH_API_VERSION_ONE}/me/drive`, { params: httpParams })
        .pipe(
          tap(response => {
            console.log(`fetched result: onedrive `, response);
            this.useCache && this.cache.set(this.cacheKey, response);
          }),
          catchError(this.httpHelper.handleError({ operation: 'getOneDrive', result: ({} as Drive), rethrow: true })),
          shareReplay({ bufferSize: 1, refCount: true }));

      if (this.useCache) {
        const cachedData = this.cache.get<Drive>(this.cacheKey);
        if (cachedData) {
          this.getOneDrive$ = of(cachedData);
        }
      }
      return this.getOneDrive$;
    }
  }

  getFile(fileName: string): Observable<DriveItem> {

    const fetchOperation = this.http.get<DriveItem>(`${Constants.GRAPH_API_ENDPOINT + Constants.GRAPH_API_VERSION_ONE}/me/drive/root:/` + fileName)
      .pipe(
        tap(response => {
          console.log(`fetched result: file from onedrive `, response);
        }),
        catchError(error => {
          return of(error.status);
        }));
    return fetchOperation;
  }

  uploadFile(fileName: string, rawData: string | ArrayBuffer): Observable<DriveItem> {
    return this.http.put<DriveItem>(`${Constants.GRAPH_API_ENDPOINT + Constants.GRAPH_API_VERSION_ONE}/me/drive/root:/` + fileName + `:/content`, rawData)
      .pipe(
        tap(response => {
          console.log(`uploadFile result: upload document to onedrive `, response);
          this.useCache && this.cache.removeFromPersistentCache(this.cacheKey);
        }));
  }
}
